<div class="row mt-4">
  <div class="col-1 mt-4">
    <a (click)="volverAPortal()">
      <button class="boton_volver" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i
          class="bi bi-chevron-left mr-2"></i>
        Volver
      </button>
    </a>
  </div>
  <div class="col-10">
    <h1 class="centrar_contenido">Configuración registro <br> de calificaciones</h1>
  </div>
</div>

<!-- INFORMACIÓN DE PLANILLA -->
<div class="cuadrado_gris mt-5 mb-2">
  <div class="row mt-3">
    <div class="col-5 offset-1">
      <p>Asignatura: <strong>{{ registros?.configuracion.asignatura }}</strong></p>
    </div>
    <div class="col-5 offset-1">
      <p>Periodo: <strong>{{ registros?.configuracion.periodo }}</strong></p>
    </div>
  </div>
  <div class="row ">
    <div class="col-5 offset-1">
      <p>Sede: <strong>{{ registros?.configuracion.sede }}</strong></p>
    </div>
    <div class="col-5 offset-1">
      <p>Estado: <strong>{{ registros?.configuracion.estado }}</strong></p>
    </div>
  </div>
  <div class="row ">
    <div class="col-5 offset-1">
      <p *ngIf="registros?.configuracion.fechaActualizacion != null">Fecha modificación: <strong>{{
          registros?.configuracion.fechaActualizacion }} </strong></p>
      <p *ngIf="registros?.configuracion.fechaActualizacion == null">Fecha modificación: <strong>-</strong></p>
    </div>
    <div class="col-5 offset-1">
    </div>
  </div>
  <div class="row">
    <div class="col-1 mr-1 offset-1">
      <p>Docente(s):</p>
    </div>
    <div *ngFor="let docentes of registros?.configuracion.docentes; last as isLast">
      <p class="mx-1"> <strong>{{ docentes }}</strong>
        <i class="bi bi-dash mx-3" *ngIf="!isLast"></i>
      </p>
    </div>
  </div>
</div>
<span>* Recuerda que debes hacer clic en el botón <strong>GUARDAR</strong> para realizar los cambios de
  configuración.</span>
<!-- FIN INFORMACIÓN DE PLANILLA -->

<div>
  <div *ngIf="textoError" class="alert alert-danger tipografía_alertas mt-4 mb-4" role="alert">
    <i class="bi bi bi-x-circle tamanio_iconos-boton mr-2"></i>{{ textoError }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close"
      data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true"
      aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>
</div>

<div *ngIf="alertaExitosa !== ''" class="alert alert-success tipografía_alertas mt-4 mb-4" role="alert">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
  {{ alertaExitosa }}
</div>

<!-- PONDERACION CALIF. PARCIALES -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Ponderación calificaciones parciales</h6>
</div>

<div class="borde_cuadrado-negro mt-5" *ngIf="!isLoading">
  <div class="row">
    <div class="col-10 offset-1">
      <div class="row mt-5 align-items-center">
        <div class="cuadrado-amarillo mr-3"></div>
        <p class="mb-0">Especifique a continuación el número de calificaciones parciales:</p>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-5">
    <div class="col-10 pl-0">
      <p class="cant-calificaciones d-inline pl-4">Cantidad de calificaciones <span class="cantidad-minima-span">(cantidad mínima: {{ minParciales }})</span></p>
      <label class="valores_configuracion mx-4"> </label>

      <button [disabled]="calificacionesParciales.length == minParciales || esVerDetalle"
        class="boton-menos valores_configuracion mx-2"
        [ngClass]="calificacionesParciales.length == minParciales ? 'disabled-button disabled-button-menos' : '' || esVerDetalle ? 'disabled-button disabled-button-menos' : ''"
        (click)="quitarCalif('calificacionesParciales')">
        <i class="bi bi-dash"></i>
      </button>
      <input [disabled]="esVerDetalle"  [value]="calificacionesParciales.length"
        class="ancho_input mx-4 valores_configuracion text-center" placeholder="0" type="number"
        (keyup)="ingresoCajasPonderaciones('calificacionesParciales')" [(ngModel)]="cantidadCajasParciales" max="20"
        min="{{ minParciales }}">

      <button [disabled]="calificacionesParciales.length >= maxParciales || esVerDetalle"
        class="boton-mas valores_configuracion"
        [ngClass]="calificacionesParciales.length >= maxParciales ? 'disabled-button disabled-button-menos' : '' || esVerDetalle ? 'disabled-button disabled-button-mas' : ''"
        (click)="agregarCalif('calificacionesParciales')">
        <i class="bi bi-plus"></i>
      </button>

      <label class="hr-negro mx-4">|</label>
      <span class="ml-4">% Total:
        <label class="valores_configuracion ml-3">{{ totalParciales() }}</label>
        <i *ngIf="totalParciales() != 100" class="bi bi-exclamation-triangle tamanio_iconos-boton color_triangulo"
          class="bi bi-exclamation-triangle position-relative ml-2 tamanio_iconos-boton color_triangulo">
          <span class="alert-hover-config alert-hover-config-parciales" [ngClass]="totalParciales() > 100 ? 'alert-hover-config-100' : ''"></span>
        </i>
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-11 offset-1">
      <div class="row mt-5 align-items-baseline">
        <div class="cuadrado-amarillo mr-3"></div>
        <p class="mb-0">Especifique a continuación las ponderaciones de cada calificación.
        </p>
      </div>
    </div>
  </div>

  <div class="row mt-3 mb-4 mr-5 offset-1">

    <ng-container *ngFor="let calificacion of calificacionesParciales; index as i">
      <div class="col-5 mt-3 cuadrado_gris altura_caja_secundaria centrar_contenido mr-4" [ngClass]="{'mb-5': calificacion.porcentaje == 0 || calificacion.porcentaje == null, 'cuadrado-gris-disabled': esVerDetalle}" min="1" max="20">
        <p class="mb-0">% CP{{ i + 1 }}:
          <input class="ancho_input" [disabled]="esVerDetalle" type="number" [(ngModel)]="calificacion.porcentaje" min="0"
            max="100" maxlength="3" [ngClass]="calificacion.porcentaje == 0 || calificacion.porcentaje == null ? 'cstm-border-warning' : ''">
        </p>
        <form action="">
          <textarea [disabled]="esVerDetalle" [(ngModel)]="calificacion.glosa" [ngModelOptions]="{standalone: true}"
            class="form-control select_criterios input_text_area" placeholder="Glosa calificaciones parciales..."
            id="exampleFormControlTextarea1" rows="3" maxlength="100"></textarea>
        </form>
  
        <p class="cstm-info-warning w-100" *ngIf="calificacion.porcentaje == 0 || calificacion.porcentaje == null">
          <i class="bi bi-exclamation-triangle-fill"></i> La ponderación debe ser superior a 0
        </p>
      </div>
    </ng-container>


  </div>
</div>
<!-- FIN PONDERACION CALIF. PARCIALES -->

<!-- PONDERACION EXAMENES -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Ponderación examen</h6>
</div>

<div class="borde_cuadrado-negro mt-5" *ngIf="!isLoading">
  <div class="row">
    <div class="col-10 offset-1">
      <div class="row mt-5 align-items-center">
        <div class="cuadrado-amarillo mr-3"></div>
        <p class="mb-0">Especifique a continuación el número de partes del examen:</p>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-5">
    <div class="col-10 pl-0">
      <p class="cant-calificaciones d-inline pl-4">Cantidad de calificaciones <span class="cantidad-minima-span">(cantidad mínima: {{ minExamenes }})</span></p>
      <label class="valores_configuracion mx-4"></label>

      <button class="boton-menos valores_configuracion mx-2"
        [disabled]="calificacionesExamenes.length == minExamenes || esVerDetalle"
        (click)="quitarCalif('calificacionesExamenes')"
        [ngClass]="calificacionesExamenes.length == minExamenes ? 'disabled-button disabled-button-menos' : '' || esVerDetalle ? 'disabled-button disabled-button-menos' : ''">
        <i class="bi bi-dash"></i>
      </button>
      <input type="number" [disabled]="esVerDetalle" [value]="calificacionesExamenes.length"
        class="ancho_input mx-4 valores_configuracion" (keyup)="ingresoCajasPonderaciones('calificacionesExamenes')"
        [(ngModel)]="cantidadCajasExamenes" min="{{ minExamenes }}" max="2">
      <button class="boton-mas valores_configuracion"
        [disabled]="calificacionesExamenes.length >= maxExamenes || esVerDetalle"
        (click)="agregarCalif('calificacionesExamenes')"
        [ngClass]="calificacionesExamenes.length >= maxExamenes ? 'disabled-button disabled-button-mas' : '' || esVerDetalle ? 'disabled-button disabled-button-mas' : ''">
        <i class="bi bi-plus"></i>
      </button>


      <label class="hr-negro ml-3 mr-4">|</label>
      <span class="ml-4">% Total:</span>
      <label class="valores_configuracion ml-3">{{ totalExamenes() }}</label>
      <i *ngIf="totalExamenes() != 100 && calificacionesExamenes.length != 0"
        class="bi bi-exclamation-triangle position-relative ml-2 tamanio_iconos-boton color_triangulo" data-toggle="tooltip"
        data-placement="top" alt="test">
        <span class="alert-hover-config alert-hover-config-parciales" [ngClass]="totalExamenes() > 100 ? 'alert-hover-config-100' : ''"></span>
      </i>
    </div>
  </div>

  <div class="row">
    <div class="col-11 offset-1">
      <div class="row mt-5 align-items-baseline">
        <div class="cuadrado-amarillo mr-3"></div>
        <p class="mb-0">Especifique a continuación las ponderaciones de cada calificación.
        </p>
      </div>
    </div>
  </div>

  <div class="row mt-2 mb-5 mr-5 offset-1">
    <!-- parte examen -->
    <ng-container *ngFor="let calificacionEx of calificacionesExamenes; index as i">
      <div class="col-5 mt-3 cuadrado_gris altura_caja_secundaria centrar_contenido mr-4" [ngClass]="{'mb-5': calificacionEx.porcentajeE == 0 || calificacionEx.porcentajeE == null, 'cuadrado-gris-disabled': esVerDetalle}">
        <p class="mb-0">% CE{{ i + 1 }}:
          <input class="ancho_input" [disabled]="esVerDetalle" type="number" [(ngModel)]="calificacionEx.porcentajeE">
        </p>
        <form action="">
          <textarea [disabled]="esVerDetalle" [(ngModel)]="calificacionEx.glosa" [ngModelOptions]="{standalone: true}"
            class="form-control select_criterios input_text_area" placeholder="Glosa calificación examen..."
            id="exampleFormControlTextarea1" rows="3" maxlength="100"></textarea>
        </form>

        <p class="cstm-info-warning w-100" *ngIf="calificacionEx.porcentajeE == 0 || calificacionEx.porcentajeE == null">
          <i class="bi bi-exclamation-triangle-fill"></i> La ponderación debe ser superior a 0
        </p>
      </div>
    </ng-container>
  </div>

  <div class="row mb-5 mt-5" *ngIf="calificacionesExamenes.length>0">
    <div class="col-4 offset-1 pl-0 d-flex align-items-flex-start mt-5">
      <span class="mr-5">¿Aplica examen extraordinario?</span>
      <label class="switch" hidden>
        <input type="checkbox" [disabled]="true" (click)="switchExamenExtraordinario()"
          [checked]="activarExamenExtraordinario">
        <span class="slider round" style="opacity: 55% !important;"></span>
      </label>
      <span>{{ activarExamenExtraordinario ? 'Si' : 'No' }}</span>
    </div>
    <ng-container *ngIf="activarExamenExtraordinario">
      <div class="col-2 borde_cuadrado-negro altura_caja_secundaria mr-3 centrar_contenido"
        *ngFor="let calificacionEx of calificacionesExamenes; index as i">
        <p class="mb-0">% Calif. {{ i + 1 }}:
          <input class="ancho_input" type="number" [(ngModel)]="calificacionEx.porcentajeE" disabled>
        </p>
      </div>
    </ng-container>
  </div>
</div>
<!-- FIN PONDERACION EXAMENES -->

<div class="mb-5 mt-5 centrar_contenido">
  <button 
    *ngIf="!esVerDetalle" 
    (click)="validarNotas()"
    class="boton-primario tamanio_minimo ml-3 mb-4" 
    data-toggle="tooltip" 
    data-placement="top" 
    title="GUARDAR" 
    alt="GUARDAR">GUARDAR
  </button>
  <a (click)="volverAPortal()">
    <button *ngIf="esVerDetalle" class="boton-secundario mb-4" data-toggle="tooltip" data-placement="top" title="CERRAR"
      alt="CERRAR">
      CERRAR
    </button>
  </a>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>

<!-- MODAL CERRAR CURSO -->
<button id="modal-confirmar" class="btn ocultar-mobile d-none" data-toggle="modal" data-target="#confirmar">CERRAR CURSO 1</button>
<div class="modal fade" id="confirmar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header align-items-center">
              <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                  <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
              </button>
          </div>
          <div class="modal-body">
              <form>
                  <div class="row align-items-center my-3 mx-4">
                      <p class="mb-0 ml-3">¿Estás seguro/a que deseas guardar la modificación registro de calificaciones?</p>
                  </div>
              </form>
          </div>
          <div class="modal-footer justify-content-center">
              <div class="my-4">
                <button
                  class="boton_secundario_modal ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="SI" alt="SI"
                  (click)="guardar()"
                  data-dismiss="modal">
                  SI
                </button>
                <button
                  class="boton-primario ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="NO"
                  alt="NO" data-dismiss="modal">
                  NO
                </button>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- FIN MODAL CERRAR CURSO -->

<app-modal-ponderacion-notas-previas (cstmFn)="guardar()"></app-modal-ponderacion-notas-previas>